import { ChakraText } from '@equip.health/ui';

const General = () => <ChakraText>General</ChakraText>;

export default General;
